import { type ReactNode } from "react";

/**
 * The Earwise wordmark: the brand "E" mark (matching the app icon — ink spine
 * and arms with a burgundy middle bar) set as the capital letter, followed by
 * "arwise". The E inherits the surrounding text color via `fill-current`, so it
 * picks up hover/active states just like the rest of the link.
 */
export function EarwiseWordmark({ className }: { className?: string }): ReactNode {
  return (
    <span
      role="img"
      aria-label="Earwise"
      className={`inline-flex items-baseline leading-none ${className ?? ""}`}
    >
      <svg
        viewBox="0 0 392 424"
        aria-hidden="true"
        focusable="false"
        className="h-[0.72em] w-auto"
      >
        <rect x="0" y="0" width="392" height="92" rx="26" className="fill-current" />
        <rect x="0" y="166" width="300" height="92" rx="26" className="fill-accent" />
        <rect x="0" y="332" width="392" height="92" rx="26" className="fill-current" />
        <rect x="0" y="0" width="80" height="424" rx="22" className="fill-current" />
      </svg>
      <span aria-hidden="true" className="ml-[0.1em]">
        arwise
      </span>
    </span>
  );
}
